import { TDocumentDefinitions } from "pdfmake/interfaces";
import getHeader from "report/common/header";
import getLogo from "report/common/logo";
import getFooter from "report/common/footer";
import getMap from "report/common/map";
import getLegend from "report/common/legend";
import getReportInfo from "./sections/report-info/report-info";
import getHazard from "./hazard/hazard";
import { info } from "report/common/meta";
import { PolygonReportParam } from "./types";
import page from "report/common/page";

/**
 * 图例的 CSS 选择器 - 用于 dom-to-image 截图
 * 选中显示分析结果的所有图例元素（包括多边形分析和绘制线图例）
 * 参考：line 报告使用 [class^="agenda_agenda"]
 */
const POLYGON_REPORT_LEGEND_SELECTOR =
  '[class^="agenda_agenda"], [class^="multipleAgenda_multipleAgenda"], [class^="DrawLineAgenda_drawLineAgenda"]';

/**
 * 生成区域分析报告 PDF 文档定义
 */
const getDoc = async ({
  t,
  polygonName,
  polygonArea,
  analysisItems,
  legendItems,
  layerStatistics,
  analysisResult,
  selectedShapeId
}: PolygonReportParam): Promise<TDocumentDefinitions> => {
  // 验证必要数据
  if (!layerStatistics || layerStatistics.length === 0) {
    console.warn("No layer statistics provided");
  }

  const docDefinition: TDocumentDefinitions = {
    pageMargins: [20, 60, 20, 30],

    header: (currentPage, pageCount) =>
      currentPage === 1 ? getHeader(t("report.CatNet")) : getLogo(),

    footer: (currentPage, pageCount) => getFooter(t, currentPage, pageCount),

    content: [
      // 第 1 页：报告详情（满宽一行）
      {
        stack: getReportInfo(t, { polygonName, polygonArea })
      },

      // 第 1 页：地图 + 图例（两列）
      {
        marginTop: 15,
        columns: [
          {
            width: "45%",
            stack: [
              ...(await getMap(t("report.Map View"))),
              {
                text: "*" + t("report.Map Description"),
                fontSize: 7,
                opacity: 0.5,
                marginTop: 5
              }
            ]
          },
          {
            width: "55%",
            stack: await getLegend(
              t("report.Map Legends"),
              POLYGON_REPORT_LEGEND_SELECTOR,
              selectedShapeId
            )
          }
        ],
        columnGap: 50
      },

      // 第 2+ 页：灾害分析
      page(),
      getHazard(t, layerStatistics, analysisResult, legendItems)
    ],

    info: info,

    defaultStyle: {
      font: "普惠体",
      fontSize: 8,
      opacity: 0.6,
      lineHeight: 1,
      characterSpacing: 0
    }
  };

  return docDefinition;
};

export default getDoc;
